var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"splash-screen-wrapper",attrs:{"fill-height":"","align-center":"","justify-center":""}},[_c('v-img',{attrs:{"src":require('@/assets/logo.png'),"max-width":"10%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }